<template>
  <i class="fa" :class="[checked ? 'fa-check-square-o' : 'fa-square-o']" aria-hidden="true"></i>
</template>
<script>
export default {
  props: ['checked'],
  name: 'check-icon'
}
</script>



// WEBPACK FOOTER //
// src/components/shared/CheckIcon.vue